// src/pages/invites/AcceptInvitePage.jsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { auth } from "../../services/auth";

export default function AcceptInvitePage() {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, refresh } = useAuth();
  const token = new URLSearchParams(loc.search).get("token");
  const [loading, setLoading] = useState(true);
  const [invite, setInvite] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) {
      setErr("Missing invite token.");
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/invites/${encodeURIComponent(token)}`);
        if (!r.ok) throw new Error("Invalid or expired invite.");
        const d = await r.json(); // { email, role, orgName }
        setInvite(d);

        if (!user) {
          // Not signed in → go to register with invite
          nav(`/register?invite=${encodeURIComponent(token)}`, { replace: true });
          return;
        }

        // Signed in: email must match
        if (user.email?.toLowerCase() !== d.email.toLowerCase()) {
          setLoading(false);
          return; // will render mismatch UI
        }

        // Accept immediately
        const a = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/invites/${encodeURIComponent(token)}/accept`, {
          method: "POST",
          credentials: "include",
        });
        if (!a.ok) throw new Error("Accept failed.");
        await refresh();
        nav("/dashboard", { replace: true });
      } catch (e) {
        setErr(e.message || "Invite error.");
        setLoading(false);
      }
    })();
  }, [token, user, nav, refresh]);

  if (loading) return <div className="p-6">Checking your invitation…</div>;
  if (err) return <div className="p-6 text-red-600">{err}</div>;

  // Email mismatch UI when logged in with a different email
  return (
    <div className="p-6 max-w-lg">
      <h1 className="text-xl font-bold mb-3">This invite is for {invite?.email}</h1>
      <p className="text-gray-600 mb-4">
        You’re currently signed in as <b>{user?.email}</b>. Please sign out and continue with <b>{invite?.email}</b>.
      </p>
      <div className="flex gap-2">
        <button
          className="px-4 py-2 border rounded"
          onClick={() => nav("/dashboard")}
        >
          Go to dashboard
        </button>
        <button
          className="px-4 py-2 bg-black text-white rounded"
          onClick={async () => {
            try { await auth.logout(); } catch {}
            window.location.replace(`/register?invite=${encodeURIComponent(token)}`);
          }}
        >
          Sign out & Register
        </button>
      </div>
    </div>
  );
}
